import React from 'react';
import { ChevronRight } from 'lucide-react';
import { benefits } from '../mock';

const IntroSection = () => {
  return (
    <section className="bg-white">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 pt-16 pb-8">
        <div className="flex items-center justify-center gap-2 text-sm text-slate-500 mb-8">
          <a href="#" className="hover:text-[#E63946]">Home</a>
          <ChevronRight className="w-4 h-4" />
          <a href="#" className="hover:text-[#E63946]">Software Services</a>
          <ChevronRight className="w-4 h-4" />
          <span className="text-[#E63946]">SaaS Application Development</span>
        </div>
        <h2 className="text-center text-[30px] md:text-[42px] font-bold text-slate-900 leading-tight">
          Software As a Service Development Company
        </h2>
        <p className="mt-6 text-center text-slate-600 max-w-3xl mx-auto leading-relaxed">
          In today's fast-moving world, businesses need smart, secure, and scalable SaaS solutions to keep up and grow. Whether you're a startup with a big idea or an enterprise looking to upgrade and streamline your systems, the right technology can make all the difference. At Kamikatazi Corp, we work alongside you to build custom cloud-based SaaS applications, now precisely infused with AI to deliver more personalized experiences. With over 15 years of hands-on experience, we're here to transform your vision into a practical, future-proof solution that drives real results and helps your business thrive.
        </p>
      </div>
      <div className="bg-[#f6f7fb] py-16">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          <p className="text-center text-slate-600 max-w-3xl mx-auto mb-4 leading-relaxed">
            Markets move fast, and so do the challenges that come with them. As your business grows, so does the complexity of managing operations, teams, tools, and systems. Sometimes, building something in-house only makes things harder.
          </p>
          <p className="text-center text-slate-600 max-w-3xl mx-auto mb-12 leading-relaxed">
            That's where we come in. At Kamikatazi Corp, we build SaaS products that are simple to manage, quick to launch, and far less demanding than assembling an in-house tech team.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((b) => (
              <div key={b.title} className="bg-white rounded-2xl p-7 shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_10px_30px_rgba(230,57,70,0.12)] hover:-translate-y-1 transition-all duration-300 border border-slate-100">
                <div className="w-12 h-12 rounded-xl bg-red-50 flex items-center justify-center mb-4">
                  <b.icon className="w-6 h-6 text-[#E63946]" />
                </div>
                <h3 className="text-[20px] font-bold text-slate-900 mb-2">{b.title}</h3>
                <p className="text-slate-600 text-[15px] leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
